const setToken = ({ commit }, token) => commit('setToken', token)

const setHashToken = ({ commit }, hashToken) => commit('setHashToken', hashToken)

export default {
    setToken,
    setHashToken
}
